(function () {
  function clampQty(value) {
    var number = Number(value || 1);

    if (Number.isNaN(number)) {
      number = 1;
    }

    return Math.max(1, Math.min(10, number));
  }

  function formatTimerNumber(value) {
    return String(value).padStart(2, "0");
  }

  function initTimer(root) {
    var timer = root.querySelector("[data-adk-timer]");

    if (!timer) {
      return;
    }

    var minEl = timer.querySelector("[data-adk-min]");
    var secEl = timer.querySelector("[data-adk-sec]");
    var minutes = Number(timer.getAttribute("data-minutes") || 15);
    var total = Math.max(1, minutes) * 60;

    function tick() {
      var mins = Math.floor(total / 60);
      var secs = total % 60;

      if (minEl) {
        minEl.textContent = formatTimerNumber(mins);
      }

      if (secEl) {
        secEl.textContent = formatTimerNumber(secs);
      }

      total = total > 0 ? total - 1 : Math.max(1, minutes) * 60;
    }

    tick();
    window.setInterval(tick, 1000);
  }

  function initOptions(root) {
    var options = Array.prototype.slice.call(root.querySelectorAll(".adk-option"));

    options.forEach(function (option) {
      var input = option.querySelector(".adk-choice-input");
      var qtyInput = option.querySelector(".adk-qty-input");
      var minus = option.querySelector(".adk-qty-minus");
      var plus = option.querySelector(".adk-qty-plus");

      function syncActive() {
        if (!input) {
          return;
        }

        option.classList.toggle("is-active", input.checked);
      }

      option.addEventListener("click", function (event) {
        if (
          event.target.closest("button") ||
          event.target.closest("input") ||
          option.classList.contains("is-disabled")
        ) {
          return;
        }

        if (input) {
          input.checked = !input.checked;
          syncActive();
        }
      });

      if (input) {
        input.addEventListener("change", syncActive);
      }

      if (minus && qtyInput) {
        minus.addEventListener("click", function () {
          qtyInput.value = clampQty(Number(qtyInput.value) - 1);
        });
      }

      if (plus && qtyInput) {
        plus.addEventListener("click", function () {
          qtyInput.value = clampQty(Number(qtyInput.value) + 1);
        });
      }

      if (qtyInput) {
        qtyInput.addEventListener("change", function () {
          qtyInput.value = clampQty(qtyInput.value);
        });
      }

      syncActive();
    });
  }

  function selectedItems(root) {
    var selected = Array.prototype.slice.call(
      root.querySelectorAll(".adk-option .adk-choice-input:checked")
    );

    return selected
      .map(function (input) {
        var option = input.closest(".adk-option");
        var qtyInput = option ? option.querySelector(".adk-qty-input") : null;
        var variantId = option ? Number(option.getAttribute("data-variant-id")) : 0;

        if (!variantId || option.classList.contains("is-disabled")) {
          return null;
        }

        return {
          id: variantId,
          quantity: qtyInput ? clampQty(qtyInput.value) : 1
        };
      })
      .filter(Boolean);
  }

  function addItems(items) {
    return fetch("/cart/add.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify({
        items: items
      })
    }).then(function (response) {
      if (!response.ok) {
        throw new Error("Add to cart failed");
      }

      return response.json();
    });
  }

  function initBuyButton(root) {
    var buyButton = root.querySelector("[data-adk-buy]");

    if (!buyButton) {
      return;
    }

    var checkoutMode = root.getAttribute("data-checkout-mode") || "checkout";
    var originalText = buyButton.textContent;

    buyButton.addEventListener("click", function () {
      var items = selectedItems(root);

      if (!items.length) {
        window.alert("Please select at least one option first.");
        return;
      }

      buyButton.setAttribute("disabled", "disabled");
      buyButton.textContent = checkoutMode === "cart" ? "Adding..." : "Redirecting...";

      addItems(items)
        .then(function () {
          if (checkoutMode === "cart") {
            window.location.href = "/cart";
          } else {
            window.location.href = "/checkout";
          }
        })
        .catch(function () {
          buyButton.removeAttribute("disabled");
          buyButton.textContent = originalText;
          window.alert("Sorry, something went wrong. Please try again.");
        });
    });
  }

  function initAdvertorial(root) {
    initTimer(root);
    initOptions(root);
    initBuyButton(root);
  }

  document.addEventListener("DOMContentLoaded", function () {
    var roots = document.querySelectorAll("[data-product-advertorial]");

    roots.forEach(function (root) {
      initAdvertorial(root);
    });
  });

  document.addEventListener("shopify:section:load", function (event) {
    var root = event.target.querySelector("[data-product-advertorial]");

    if (root) {
      initAdvertorial(root);
    }
  });
})();